var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c("div", [
      _vm._v(
        "\n    Welcome to your BedBoard App. Use the features in this app to easily view and manage your clients' stays at the locations you need to monitor. Customize the layout settings and the list of units you want to view in your user preferences.\n  "
      )
    ]),
    _vm.isOccupancyReportViewable
      ? _c(
          "div",
          { staticStyle: { "margin-top": "30px" } },
          [
            _vm.isBusy
              ? _c(
                  "v-flex",
                  { staticClass: "text-xs-center" },
                  [_c("busy-animation")],
                  1
                )
              : _vm.occupancyReportPayload
                ? _c(
                    "div",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", [
                            _c("div", { staticClass: "occupancyReportTitle" }, [
                              _vm._v(
                                _vm._s(_vm.occupancyReportPayload.reportTitle)
                              )
                            ])
                          ]),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticStyle: {
                                    float: "right",
                                    "margin-left": "10px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.runReport()
                                    }
                                  }
                                },
                                [_vm._v("Run Report")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.occupancyReportPayload.lastRunDate
                        ? _c(
                            "span",
                            {
                              staticClass: "occupancyLastRun",
                              staticStyle: { float: "right" }
                            },
                            [
                              _vm._v(
                                "Last run: " +
                                  _vm._s(
                                    _vm._f("moment")(
                                      _vm.occupancyReportPayload.lastRunDate,
                                      "M/D/YYYY h:mm a"
                                    )
                                  )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "table",
                        {
                          staticClass: "occupancyReportTable",
                          attrs: { "cell-spacing": "0", cellpadding: "0" }
                        },
                        [
                          _c(
                            "tbody",
                            _vm._l(_vm.occupancyReportPayload.rows, function(
                              row,
                              index
                            ) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  { staticClass: "occupancyReportRowTitle" },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getIndent(row.level)
                                        )
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(row.title))
                                  ]
                                ),
                                row.showValues
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "occupancyReportRowTitle"
                                      },
                                      [
                                        _c("table", [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowLabel"
                                                },
                                                [_vm._v("Maximum")]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowValue"
                                                },
                                                [_vm._v(_vm._s(row.maximum))]
                                              )
                                            ]),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowLabel"
                                                },
                                                [_vm._v("Occupied")]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowValue"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(row.occupied) +
                                                      " (" +
                                                      _vm._s(
                                                        row.occupiedPercentage
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowLabel"
                                                },
                                                [_vm._v("Reserved")]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowValue"
                                                },
                                                [_vm._v(_vm._s(row.reserved))]
                                              )
                                            ]),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowLabel"
                                                },
                                                [_vm._v("Available")]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "occupancyReportRowValue"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(row.available) +
                                                      " (" +
                                                      _vm._s(
                                                        row.availablePercentage
                                                      ) +
                                                      ")"
                                                  )
                                                ]
                                              )
                                            ])
                                          ])
                                        ])
                                      ]
                                    )
                                  : _c("td", {
                                      staticClass: "occupancyReportRowTitle"
                                    })
                              ])
                            })
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _c("div", [_vm._v("\n      No occupancy report data\n    ")])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("BedBoard App")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }